import axios from "axios";
import { api } from "./helper";
import router from "../routes/routes";
import store from "../store"
import { v4 as uuidv4 } from 'uuid';

function prepareDataRequest(data) {
  return {
    RequestCorrelationId: uuidv4(),
    Data: data
  };
}

function prepareRequest(data) {
  return {
    ...data,
    RequestCorrelationId: uuidv4()
  };
}

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

client.interceptors.response.use(
  (response) => {
    if (!response.data)
      if (response.data.indexOf("Unauthorized") > -1) {
        router.push("/logout");
      }
    return response;
  },
  (error) => {
    return { data: error.message };
  }
);

function GetCommRegions() {
  return client.post("CommRegions/GetCommRegions", prepareRequest({}));
}

function UpdateCommRegions(item) {
  return client.post("CommRegions/UpdateCommRegion", prepareDataRequest(item));
}

function DeleteCommRegions(item) {
  return client.post("CommRegions/DeleteCommRegion", prepareDataRequest(item));
}

export {
  GetCommRegions,
  UpdateCommRegions,
  DeleteCommRegions
};